import React from 'react';
import PropTypes from 'prop-types';
import withTranslate from 'containers/widgets/withTranslate';
import Icon, { IconSizes, IconVariants } from 'components/foundations/Icon';
import ExpandablePanel from 'components/widgets/ExpandablePanel';
import QuestionField from './QuestionField';
import css from './ContextSection.css';

const ContextSection = React.forwardRef(
    ({ section, answers, maxLengths, isOpen, onToggle, onChange, readOnly = false, translate }, ref) => {
        const header = (
            <div className={css.header}>
                <div className={css.iconWrapper}>
                    <Icon name={section.icon} size={IconSizes.MEDIUM} variant={IconVariants.DARK} interactive={false} />
                </div>
                <div className={css.meta}>
                    <div className={css.title}>{translate(section.name)}</div>
                    <div className={css.description}>{translate(section.description)}</div>
                </div>
            </div>
        );

        return (
            <div ref={ref} id={`section-${section.id}`} data-section-id={section.id} className={css.sectionAnchor}>
                <ExpandablePanel
                    id={section.id}
                    expanded={isOpen}
                    onExpandClick={onToggle}
                    header={header}
                    overrideClasses={{
                        container: css.panel,
                        headerContainer: css.panelHeader,
                        arrowArea: css.arrowArea,
                        externalHeaderArea: css.externalHeaderArea,
                        contentArea: css.contentArea,
                    }}
                >
                    <div className={css.questions}>
                        {section.questions.map(question => (
                            <QuestionField
                                key={question.id}
                                question={question}
                                maxLength={maxLengths[question.id]}
                                value={answers[question.id]}
                                onChange={onChange}
                                readOnly={readOnly}
                            />
                        ))}
                    </div>
                </ExpandablePanel>
            </div>
        );
    }
);

ContextSection.displayName = 'ContextSection';

ContextSection.propTypes = {
    section: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired,
        description: PropTypes.string.isRequired,
        icon: PropTypes.string.isRequired,
        questions: PropTypes.arrayOf(
            PropTypes.shape({
                id: PropTypes.string.isRequired,
                title: PropTypes.string.isRequired,
                description: PropTypes.string.isRequired,
                placeholder: PropTypes.string,
            })
        ).isRequired,
    }).isRequired,
    answers: PropTypes.objectOf(PropTypes.string).isRequired,
    maxLengths: PropTypes.objectOf(PropTypes.number).isRequired,
    isOpen: PropTypes.bool.isRequired,
    onToggle: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    readOnly: PropTypes.bool,
    translate: PropTypes.func.isRequired,
};

export default withTranslate(ContextSection);
